import { getJwtToken } from 'util/auth';
import { setContext } from '@apollo/client/link/context';

export const authLink = setContext(async () => {
  // The authLink always put the authorization data into the headers before sending request http
  // The function getJwtToken() is using the method Auth.currentSession() to get authorization data
  // Notice: Auth.currentSession() will refresh the token if the accessToken is expired
  const jwtToken = await getJwtToken();

  return {
    headers: {
      authorization: jwtToken
    }
  };
});
